import { render, staticRenderFns } from "./subcribePlan.vue?vue&type=template&id=a59e0e36&scoped=true&"
import script from "./subcribePlan.vue?vue&type=script&lang=js&"
export * from "./subcribePlan.vue?vue&type=script&lang=js&"
import style0 from "./subcribePlan.vue?vue&type=style&index=0&id=a59e0e36&scoped=true&lang=css&"
import style1 from "./subcribePlan.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59e0e36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a59e0e36')) {
      api.createRecord('a59e0e36', component.options)
    } else {
      api.reload('a59e0e36', component.options)
    }
    module.hot.accept("./subcribePlan.vue?vue&type=template&id=a59e0e36&scoped=true&", function () {
      api.rerender('a59e0e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/subcribePlan.vue"
export default component.exports